import React, { createContext, useContext, useState } from "react";

// Create Context
const ToasterContext = createContext();

// ToasterProvider component to provide context
export const ToasterProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  // Function to add a new toast
  const addToast = (message, type = "success") => {
    if (toasts.length > 4) {
      removeToast(toasts[0].id);
    }

    setToasts((prevToasts) => [
      ...prevToasts,
      { message, type, id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}` },
    ]);
  };

  const toaster = {
    primary: (message) => addToast(message, "primary"),
    secondary: (message) => addToast(message, "secondary"),
    success: (message) => addToast(message, "success"),
    error: (message) => addToast(message, "danger"),
    warning: (message) => addToast(message, "warning"),
    info: (message) => addToast(message, "info"),
    light: (message) => addToast(message, "light"),
    dark: (message) => addToast(message, "dark"),
  };

  // Function to remove a toast by id
  const removeToast = (id) => {
    setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
  };

  return (
    <ToasterContext.Provider value={{ toasts, toaster, removeToast }}>
      {children}
    </ToasterContext.Provider>
  );
};

// Custom hook to use the Toaster context
export const useToaster = () => useContext(ToasterContext);
